
import Vue from "vue";
import { currentTimeZone, validateTimezone } from "@/helpers";
import { format, formatInTimeZone, zonedTimeToUtc } from "date-fns-tz";
import { updateTable, setFieldToNULL } from "@/api";

export default Vue.extend({
  name: "EditDate",
  props: [
    "className",
    "columnName",
    "item",
    "itemID",
    "tableName",
    "isTimeZones",
    "callback"
  ],
  data: () => {
    return {
      dateProps: {
        headerColor: "green darken-4"
      },
      timeProps: {
        ampmInTitle: true,
        format: "24hr",
        headerColor: "green darken-4",
        allowedMinutes: undefined as Function | Array<Number> | undefined
      },
      textProps: {
        hideDetails: true,
        color: "green darken-4"
      },
      datePrevTime: new Date() as Date | null,
      dateNewTime: new Date() as Date | null,
      currentTZ: currentTimeZone(),
      dialog: false
    };
  },
  mounted() {
    if (this.$store.state.tablename === "Shift") {
      this.timeProps.allowedMinutes = (m: number) => m % 15 === 0;
    }
  },
  computed: {
    datetime: {
      get(): Date | null {
        if (this.item) {
          return new Date(this.item);
        }
        return null;
      },
      set(newDate: Date): Date {
        if (this.item) {
          this.datePrevTime = new Date(this.item);
        } else {
          this.datePrevTime = null;
        }
        this.dateNewTime = newDate;
        return newDate;
      }
    }
  },
  methods: {
    updateDate(): void {
      this.dialog = true;
    },
    formatDate(date: Date): string {
      return format(new Date(date), "yyyy-MM-dd HH:mm:ss");
    },
    async sentNewDate(): Promise<void> {
      if (this.dateNewTime) {
        let formatDateNewTime: string;
        let formatDatePrevTime: string;

        if (this.isTimeZones) {
          const validTz = validateTimezone(this.isTimeZones);
          const utcNew = zonedTimeToUtc(this.dateNewTime, validTz);
          formatDateNewTime = formatInTimeZone(
            utcNew,
            "UTC",
            "yyyy-MM-dd HH:mm:ss"
          );
          formatDatePrevTime = this.datePrevTime
            ? formatInTimeZone(
                zonedTimeToUtc(this.datePrevTime, validTz),
                "UTC",
                "yyyy-MM-dd HH:mm:ss"
              )
            : formatDateNewTime;
        } else {
          formatDateNewTime = formatInTimeZone(
            this.dateNewTime,
            "UTC",
            "yyyy-MM-dd HH:mm:ss"
          );
          formatDatePrevTime = this.datePrevTime
            ? formatInTimeZone(
                this.datePrevTime,
                "UTC",
                "yyyy-MM-dd HH:mm:ss"
              )
            : formatDateNewTime;
        }

        await updateTable({
          tablename: this.tableName ?? this.$store.state.tablename,
          columnname: this.columnName,
          id: this.itemID,
          value: this.dateNewTime ? formatDateNewTime : null,
          prevValue: this.datePrevTime ? formatDatePrevTime : null
        });

        if (this.callback) {
          this.callback();
        }
      } else {
        await setFieldToNULL({
          tablename: this.$store.state.tablename,
          columnname: this.columnName,
          id: this.itemID
        });
      }
      this.dialog = false;
    }
  }
});
